<template>
  <vs-popup
    :title="title"
    :active="inputValue"
    @close="inputValue = false"
  >
    <div class="px-4 text-left leading-loose">
      <slot name="content" />
      <single-submit-button
        v-if="!hidden"
        :onclick="onClickSubmit"
        :disabled="disabled"
        class="w-full"
      >
        {{ submitButtonText }}
      </single-submit-button>
    </div>
  </vs-popup>
</template>

<script>
import SingleSubmitButton from '@/components/SingleSubmitButton'

export default {
  name: 'FormModal',
  components: {
    SingleSubmitButton
  },
  props: {
    title: {
      type: String,
      default: '登録'
    },
    modelValue: {
      type: Boolean,
      default: false
    },
    submitButtonText: {
      type: String,
      default: '登録'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'click:submit'],
  computed: {
    inputValue: {
      get () {
        return this.modelValue
      },
      set (newValue) {
        return this.$emit('update:modelValue', newValue)
      }
    }
  },
  methods: {
    onClickSubmit (event) {
      this.$emit('click:submit', event)
    }
  }
}
</script>

<style scoped>

</style>
